import type { BlocklistAddRequest, BlocklistResponse, BlocklistDataKind } from '../types';
import type { RequestFn } from '../client';

export interface BlocklistListParams {
  data_kind?: BlocklistDataKind | null;
  limit?: number | null;
  offset?: number | null;
}

export interface BlocklistToggleParams {
  status: boolean;
}

export class Blocklist {
  constructor(private readonly request: RequestFn) {}

  async add(params: BlocklistAddRequest): Promise<BlocklistResponse> {
    return this.request('POST', '/blocklist', { body: params });
  }

  async remove(params: BlocklistAddRequest): Promise<BlocklistResponse> {
    return this.request('DELETE', '/blocklist', { body: params });
  }

  async list(params?: BlocklistListParams): Promise<BlocklistResponse[]> {
    return this.request('GET', '/blocklist', {
      query: params as Record<string, string | number | undefined>,
    });
  }

  async toggle(params: BlocklistToggleParams): Promise<Record<string, unknown>> {
    return this.request('POST', '/blocklist/toggle', { body: params });
  }
}
